import Vue from 'vue';
import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { PremiumGroup } from 'frontend/types/premium/group-plans';

const premiumGroup: Module<PremiumGroup, RootState> = {
  namespaced: true,
  state: {} as PremiumGroup,
  mutations: {
    setValue(state: PremiumGroup, value: PremiumGroup) {
      Object.entries(value).forEach(([k, v]) => {
        Vue.set(state, k, v);
      });
    },
  },
  actions: {
    update({ commit }, newState: PremiumGroup) {
      commit('setValue', newState);
    },
  },
};

export default premiumGroup;
